<template>
<div class="chapter">
<div class="inner_page">
<p class="sp-brk1" id="epi"> </p>
<p class="ep">Everyone, I suppose, has shadows which pass before them at times like “ships that pass in the night.” To me one of the darkest of these shadows is that of the late Emperor of Russia and those who belonged to him. The sunbeams that light them up are the unfailing kindness which he always showed me in times of personal or other trouble, his sunny and cheerful nature, and his unfailing courage when things seemed to be going badly.</p>
<p class="epc">—Sir John Hanbury-Williams, Head of the British Military Mission at the Russian Army GHQ in World War I</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?60ce1524